import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ChefHat, Wine, Beef, MessageSquareHeart, Flame, Gift, BarChart3, Check } from 'lucide-react';
const productBullets = ['Nunca más quemar ni resecar la carne', 'Dominar el fuego desde la primera brasita', 'Conocer cada corte chileno y cómo sacarle el máximo sabor', 'Ser el papá que todos quieren que haga el asado'];
const bonuses = [{
  icon: <ChefHat className="text-bbq-gold" size={22} aria-hidden="true" data-id="element-92" />,
  n: 'Bonus 1',
  title: 'Cómo Salar la Carne como un Maestro — Masterclass',
  value: '$7.500',
  body: 'El error que comete el 90% de los parrilleros chilenos no es el fuego ni el corte. Es la sal. Esta masterclass revela el momento exacto, la cantidad exacta y la técnica exacta para que cada corte quede en su punto perfecto. El secreto que los maestros parrilleros no cuentan.'
}, {
  icon: <Wine className="text-bbq-gold" size={22} aria-hidden="true" data-id="element-93" />,
  n: 'Bonus 2',
  title: 'Guía de Vinos para Acompañar la Carne',
  value: '$12.990',
  body: 'Tu papá ya no va a apuntar al primer vino de la góndola del súper. Esta guía le dice exactamente qué vino comprar según el corte que va a preparar ese domingo. Con nombres reales, marcas chilenas accesibles y rangos de precio para cada bolsillo. Sin enredarse con términos de sommelier.'
}, {
  icon: <Beef className="text-bbq-gold" size={22} aria-hidden="true" data-id="element-94" />,
  n: 'Bonus 3',
  title: 'Los 7 Cortes Secretos del Carnicero Chileno',
  value: '$5.990',
  body: 'Hay cortes que el carnicero guarda para sus clientes de confianza. Ahora tu papá va a saber cuáles son, cómo pedirlos por su nombre exacto y para qué ocasión usar cada uno. Cortes económicos que saben mejor que el lomo vetado si sabes prepararlos.'
}, {
  icon: <MessageSquareHeart className="text-bbq-gold" size={22} aria-hidden="true" data-id="element-95" />,
  n: 'Bonus 4',
  title: 'El Mensaje que Todo Papá Quiere Recibir',
  value: '$3.990',
  body: '¿No sabes qué escribirle a tu papá junto con el regalo? Te entregamos 5 mensajes escritos especialmente para el Día del Padre chileno. Solo elige el que más se parece a tu papá, personalízalo con su nombre y envíalo por WhatsApp. Simple, emotivo y sin quedar cursi.'
}, {
  icon: <Flame className="text-bbq-gold" size={22} aria-hidden="true" data-id="element-96" />,
  n: 'Bonus 5',
  title: 'El Fuego Perfecto',
  value: '$9.990',
  body: 'El problema número uno del parrillero chileno no es la carne. Es el fuego. Esta guía PDF revela el único método para encender la parrilla bien desde la primera vez. Sin papel de diario. Sin líquido inflamable. Sin esperar 45 minutos a que prenda. En 12 minutos tienes brasas perfectas listas.'
}];
const valueStack = [{
  label: 'El Código del Asado Chileno',
  value: '$14.990'
}, {
  label: 'Bonus 1: Cómo Salar la Carne',
  value: '$7.500'
}, {
  label: 'Bonus 2: Guía de Vinos',
  value: '$12.990'
}, {
  label: 'Bonus 3: 7 Cortes Secretos',
  value: '$5.990'
}, {
  label: 'Bonus 4: El Mensaje para Papá',
  value: '$3.990'
}, {
  label: 'Bonus 5: El Fuego Perfecto',
  value: '$9.990'
}];
export function OfferSection() {
  return <section id="offer" className="bg-bbq-dark py-12 md:py-24 px-4 relative overflow-hidden" data-id="element-97">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[600px] bg-bbq-ember/10 blur-[120px] rounded-full pointer-events-none" data-id="element-98"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-99">
        <div className="text-center mb-10 md:mb-16" data-id="element-100">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white uppercase tracking-wide mb-4 leading-tight" data-id="element-101">
            Todo lo que recibe tu papá el día que le regalas esto
          </h2>
        </div>

        {/* BLOQUE 2 — PRODUCTO PRINCIPAL */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center mb-12 md:mb-20" data-id="element-102">
          {/* Image */}
          <div className="relative" data-id="element-103">
            <div className="absolute inset-0 bg-gradient-to-tr from-bbq-gold/20 to-transparent rounded-2xl blur-2xl" data-id="element-104"></div>
            
          </div>

          {/* Copy */}
          <div data-id="element-105">
            <div className="flex items-center gap-3 mb-4" data-id="element-106">
              <span className="bg-bbq-gold/10 border border-bbq-gold/30 rounded-lg p-2.5" data-id="element-107">
                <BookOpen className="text-bbq-gold" size={26} aria-hidden="true" data-id="element-108" />
              </span>
              <span className="text-bbq-gold font-display uppercase tracking-widest text-sm" data-id="element-109">
                Producto Principal
              </span>
            </div>

            <h3 className="text-2xl md:text-3xl font-display font-bold text-white uppercase tracking-wide mb-4" data-id="element-110">
              La Biblia del Asado Chileno
            </h3>

            <p className="text-gray-300 leading-relaxed mb-6" data-id="element-111">
              El manual completo para transformar a tu papá de parrillero del
              montón a maestro del asado familiar.
            </p>

            <p className="text-white font-medium mb-3" data-id="element-112">
              Aprende el método exacto para:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-113">
              {productBullets.map((bullet, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-114">
                  <span className="mt-0.5 shrink-0 bg-bbq-ember/20 text-bbq-ember rounded-full p-1" data-id="element-115">
                    <Check size={15} aria-hidden="true" data-id="element-116" />
                  </span>
                  <span data-id="element-117">{bullet}</span>
                </li>)}
            </ul>

            <p className="inline-flex items-center gap-2 text-sm text-gray-400" data-id="element-118">
              Valor real:
              <span className="text-gray-300 font-semibold line-through decoration-bbq-urgency decoration-2" data-id="element-119">
                $14.990
              </span>
            </p>
          </div>
        </motion.div>

        {/* BLOQUE 3 — LOS 5 BONUSES */}
        <div className="mb-12 md:mb-20" data-id="element-120">
          <div className="text-center mb-8 md:mb-10" data-id="element-121">
            <div className="inline-flex items-center gap-3" data-id="element-122">
              <Gift className="text-bbq-ember" size={28} aria-hidden="true" data-id="element-123" />
              <h3 className="text-2xl md:text-4xl font-display font-bold text-white uppercase tracking-wide" data-id="element-124">
                Y además, 5 bonuses de regalo
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-125">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index % 2 * 0.1
          }} className={`flex flex-col p-6 rounded-xl border bg-bbq-surface/60 border-white/5 ${index === bonuses.length - 1 && bonuses.length % 2 !== 0 ? 'md:col-span-2' : ''}`} data-id="element-126">
                <div className="flex items-start gap-4 mb-3" data-id="element-127">
                  <div className="mt-0.5 shrink-0 bg-bbq-dark p-2.5 rounded-md border border-white/5" data-id="element-128">
                    {bonus.icon}
                  </div>
                  <div data-id="element-129">
                    <span className="text-bbq-ember font-display uppercase tracking-wider text-xs" data-id="element-130">
                      {bonus.n}
                    </span>
                    <h4 className="text-lg font-bold text-white leading-snug flex flex-wrap items-center gap-2" data-id="element-131">
                      {bonus.title}
                      <span className="text-xs font-medium text-bbq-gold bg-bbq-gold/10 border border-bbq-gold/20 px-2 py-0.5 rounded-full whitespace-nowrap" data-id="element-132">
                        Valor {bonus.value} · Hoy gratis
                      </span>
                    </h4>
                  </div>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-133">
                  {bonus.body}
                </p>
              </motion.div>)}
          </div>
        </div>

        {/* BLOQUE 4 — VALUE STACK VISUAL */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gradient-to-b from-bbq-surface to-bbq-dark border border-bbq-gold/20 rounded-2xl p-8 md:p-10" data-id="element-134">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-135">
            <BarChart3 className="text-bbq-gold" size={26} aria-hidden="true" data-id="element-136" />
            <h3 className="text-xl md:text-2xl font-display font-bold text-white uppercase tracking-wide text-center" data-id="element-137">
              Mira lo que estás recibiendo
            </h3>
          </div>

          <ul className="space-y-3 mb-6" data-id="element-138">
            {valueStack.map((item, i) => <li key={i} className="flex items-center justify-between gap-4 text-gray-300 border-b border-white/5 pb-3 last:border-b-0" data-id="element-139">
                <span className="text-sm md:text-base" data-id="element-140">{item.label}</span>
                <span className="text-sm md:text-base font-semibold text-gray-400 tabular-nums shrink-0" data-id="element-141">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="border-t-2 border-dashed border-white/10 pt-6 space-y-3" data-id="element-142">
            <div className="flex items-center justify-between gap-4" data-id="element-143">
              <span className="text-gray-400 uppercase tracking-wider text-sm" data-id="element-144">
                Valor total real
              </span>
              <span className="text-xl font-display font-bold text-white line-through decoration-bbq-urgency decoration-2 opacity-70 tabular-nums" data-id="element-145">
                $55.450
              </span>
            </div>
            <div className="flex items-center justify-between gap-4" data-id="element-146">
              <span className="text-white font-semibold uppercase tracking-wider text-sm" data-id="element-147">
                Lo que pagas hoy
              </span>
              <span className="text-3xl md:text-4xl font-display font-bold text-bbq-gold tabular-nums" data-id="element-148">
                $14.990
              </span>
            </div>
            <div className="flex items-center justify-between gap-4 bg-green-500/10 border border-green-500/20 rounded-lg px-4 py-3 mt-2" data-id="element-149">
              <span className="text-green-400 font-semibold uppercase tracking-wider text-sm" data-id="element-150">
                Estás ahorrando
              </span>
              <span className="text-lg md:text-xl font-bold text-green-400 tabular-nums" data-id="element-151">
                $40.460
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}